import { Label } from '@/components/ui/label';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import type { UserType } from './userType';

export function UserTypeField({
    id,
    value,
    onChange,
    disabled,
}: {
    id: string;
    value: UserType;
    onChange: (next: UserType) => void;
    disabled?: boolean;
}) {
    return (
        <div className="space-y-2">
            <Label htmlFor={id}>User type</Label>
            <Select
                value={value}
                onValueChange={(next) => onChange(next === 'website_owner' ? 'website_owner' : 'submitter')}
                disabled={disabled}
            >
                <SelectTrigger id={id}>
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="submitter">Submitter</SelectItem>
                    <SelectItem value="website_owner">Website owner</SelectItem>
                </SelectContent>
            </Select>
            <p className="text-xs text-gray-500 dark:text-gray-400">
                {value === 'website_owner'
                    ? 'Dashboard shows tiles for your collections.'
                    : 'Dashboard shows your submissions and get in touch. This is the default.'}
            </p>
        </div>
    );
}
